import { CloudPremisePluginManager } from "@cloudpremise/portal_core";
// import Web2CasePlugin from "./web2case";
// import FirebasePlugin from "./firebase";
// import AuthPlugin from "./auth";
//NewPluginsImportPlaceHolder
//Reactforce cli would insert import line for future plugins

const plugins = [];
// if(FirebasePlugin.status){ plugins.push(FirebasePlugin); }
// if(Web2CasePlugin.status){ plugins.push(Web2CasePlugin); }
// if(AuthPlugin.status){ plugins.push(AuthPlugin); }

//NewPluginsPushPlaceHolder
//Reactforce cli would add a plugins.push line for future plugins.
//Both above placeholders are for cli to use so don't ever modify these or remove them.
const PluginManager = new CloudPremisePluginManager(plugins);

export default PluginManager;